<ul>
  {#each items as item, index}
    <li>
      <!-- Note that it's not currently possible to
      use a simple `class:` directive as Svelte
      has a bug when these are combined with
      `bind:this` and prop spreading. See
      https://github.com/sveltejs/svelte/issues/2707
      for more info. -->
      <a
        bind:this={itemAnchors[index]}
        class={item.parameters.isSubtle ? 'mh-subtle' : ''}
        href={item.parameters.href}
        {...normaliseDataAttributes(item.parameters.dataAttributes)}
      >
        {item.parameters.text}
      </a>
    </li>
  {/each}
</ul>

<style lang="less">
  @import (less) '@spotify-internal/encore-foundation/web/tokens.css';
  @import (reference) '../../../less/variables.less';

  ul {
    display: block;
    list-style: none;
    padding: 0;
  }

  li {
    display: list-item;
    padding: 0 0 22px 0;
  }

  a {
    display: inline-block;
    padding: 0;
    line-height: 1;
    font-weight: @masthead-font-weight-normal;
    font-size: @masthead-font-size-mobile-medium;
    text-decoration: none;

    &:focus,
    &:hover {
      color: currentColor;
    }
  }

  @media (min-width: @breakpoint-mobile-narrow) {
    a {
      font-size: @masthead-font-size-tablet-medium;
    }
  }

  @media (min-width: @breakpoint-tablet) {
    ul {
      min-width: 160px;
      margin: 2px 0 0 0;
      background-color: var(--solid-white-200);
      border-radius: 3px;
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
      padding: 10px 0;
      display: flex;
      flex-direction: column;
    }

    ul:before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-bottom: 16px solid var(--solid-white-200);
      top: -12px;
      right: 7px;
    }

    li {
      display: block;
      padding: 0;

      /*
       * The additional styles below
       * override encore-web global
       * styles
       */
      letter-spacing: 0;
    }

    a {
      display: block;
      line-height: 1.5;
      padding: 4px 16px 3px 16px;
      font-size: @masthead-font-size-medium;
      font-weight: @masthead-font-weight-bold;
      color: var(--solid-black-0);

      &.mh-subtle {
        color: @masthead-gray-50;
      }

      &,
      &.mh-subtle {
        &:hover,
        &:focus {
          color: currentColor;
        }
      }
    }
  }
</style>

<script>
  import { normaliseDataAttributes } from '../../../lib/normaliseDataAttributes';

  export let items;

  const itemAnchors = [];

  const moveFocus = amount => {
    const focusedIndex = itemAnchors.findIndex(
      item => document.activeElement === item,
    );

    itemAnchors[
      Math.max(0, Math.min(focusedIndex + amount, items.length - 1))
    ].focus();
  };

  export const selectNext = () => moveFocus(1);
  export const selectPrevious = () => moveFocus(-1);
</script>
